@if (items.length > 0 || (items.length === 0 && showEmptyHeaderRow)) {
  <mat-table [dataSource]="items" multiTemplateDataRows>
    @for (column of columnsDefinition; track column.fieldName) {
      <ng-container [matColumnDef]="column.fieldName">
        <mat-header-cell
          *matHeaderCellDef
          [class.cell--xs]="column.cellSizing === 'xs'"
          [class.cell--sm]="column.cellSizing === 'sm'"
          [class.cell--md]="column.cellSizing === 'md'"
          [class.cell--ml]="column.cellSizing === 'ml'"
          [class.cell--lg]="column.cellSizing === 'lg'"
          [class.cell--xl]="column.cellSizing === 'xl'"
        >
          @if (column.sortable) {
            <button class="header-cell__sort" (click)="handleSort(column.fieldName)" type="button" title="Trier">
              {{ column.title }}
              <svg [class.header-cell__sort--reverse]="sort?.order === 'desc'" width="14px" viewBox="0 0 14 14">
                <path
                  fill="currentColor"
                  d="M7 9.333a.58.58 0 0 1-.373-.135l-3.5-2.917a.583.583 0 1 1 .746-.896l3.133 2.611 3.128-2.517a.584.584 0 0 1 .732.909l-3.5 2.816a.583.583 0 0 1-.366.13Z"
                />
              </svg>
            </button>
          } @else {
            {{ column.title }}
          }
          @if (column.filters) {
            <button [matMenuTriggerFor]="filtersMenu" type="button" title="Filtrer">
              <svg class="bo-table__header__action__icon" width="12px" viewBox="0 0 18 24">
                <path
                  d="M8 24a2 2 0 0 1-2-2v-9.33a1 1 0 0 0-.2-.6L.6 5.13a3 3 0 0 1-.6-1.8V1a1 1 0 0 1 2 0v2.33a1 1 0 0 0 .2.6l5.2 6.93a3 3 0 0 1 .6 1.8V22l2-1.5v-7.83a3 3 0 0 1 .6-1.8l5.2-6.93a1 1 0 0 0 .2-.6V3a1 1 0 0 0-1-1H5a1 1 0 0 1 0-2h10a3 3 0 0 1 3 3v.33a3 3 0 0 1-.6 1.8l-5.2 6.93a1 1 0 0 0-.2.6v7.84a2 2 0 0 1-.8 1.6l-2 1.5A2 2 0 0 1 8 24z"
                />
              </svg>
            </button>
            <mat-menu #filtersMenu="matMenu">
              @for (value of column.filters; track value) {
                <button
                  [class.active]="currentFilters[column.fieldName] === value"
                  (click)="handleFilter(column.fieldName, value)"
                  mat-menu-item
                  type="button"
                >
                  {{ value }}
                </button>
              }
              <button
                [disabled]="!currentFilters[column.fieldName]"
                (click)="handleFilter(column.fieldName, null)"
                mat-menu-item
                type="button"
              >
                Réinitialiser
              </button>
            </mat-menu>
          }
        </mat-header-cell>
        <mat-cell
          *matCellDef="let row"
          [class.cell--xs]="column.cellSizing === 'xs'"
          [class.cell--sm]="column.cellSizing === 'sm'"
          [class.cell--md]="column.cellSizing === 'md'"
          [class.cell--ml]="column.cellSizing === 'ml'"
          [class.cell--lg]="column.cellSizing === 'lg'"
          [class.cell--xl]="column.cellSizing === 'xl'"
          (click)="column.clickable !== false && handleRowClick($event, row)"
        >
          @if (column.cellTemplateId) {
            <ng-container
              [ngTemplateOutlet]="cellTemplatesMap[column.cellTemplateId]"
              [ngTemplateOutletContext]="{ $implicit: row }"
            />
          } @else {
            <span [ngClass]="column.customClass">
              {{ row[column.fieldName] }}
            </span>
          }
        </mat-cell>
      </ng-container>
    }
    <ng-container matColumnDef="expandedContent">
      <mat-cell *matCellDef="let row" [attr.colspan]="columnsDefinition.length">
        <div [@expansion]="row === rowExpanded ? 'expanded' : 'collapsed'">
          @if (expandableRowTemplate) {
            <ng-container
              [ngTemplateOutlet]="expandableRowTemplate.templateRef"
              [ngTemplateOutletContext]="{ $implicit: row }"
            />
          }
        </div>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="columnNames" />
    <mat-row *matRowDef="let row; columns: columnNames" [ngClass]="rowCustomClass" />
    <mat-row
      class="row__expansion"
      *matRowDef="let row; columns: ['expandedContent']"
      [ngClass]="rowCustomClass"
      [class.row__expansion--expanded]="row === rowExpanded"
      [class.row__expansion--not-expanded]="!expandableRowTemplate || !canExpandFn || !(canExpandFn | canExpand: row)"
    />
  </mat-table>
}

@if (!items.length) {
  <p class="empty-label">
    {{ emptyListLabel || 'La liste ne contient aucun élément.' }}
  </p>
}

@if (pagination) {
  <div class="bo-table__footer">
    <mat-paginator
      [length]="pagination.itemsCount"
      [pageSize]="pagination.itemsPerPage"
      [showFirstLastButtons]="true"
      [pageIndex]="pagination.currentPage"
      [hidePageSize]="true"
      (page)="handlePaginationChange($event)"
    />
  </div>
}
